export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 bg-background-100 rounded-2xl p-8 md:p-12 border border-background-200/60">
          <div className="flex-1 text-center lg:text-left">
            <div className="inline-flex items-center px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-4">
              <i className="ri-smartphone-line mr-1.5"></i>
              移动端体验
            </div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              随时随地，吃瓜不停
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              每日爆料移动客户端已全面上线，支持iOS与Android双平台。
              推送提醒、离线阅读、夜间模式等专属功能，让你不错过任何一条劲爆爆料。
              下载App参与每日爆料大赛投票互动，还有专属新人福利等你来领。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <button className="inline-flex items-center px-5 py-2.5 bg-foreground-900 text-background-50 font-medium text-sm rounded-lg hover:bg-foreground-950 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-apple-fill mr-2 text-base"></i>
                App Store 下载
              </button>
              <button className="inline-flex items-center px-5 py-2.5 bg-background-50 text-foreground-700 font-medium text-sm rounded-lg border border-background-200 hover:border-primary-300 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-android-fill mr-2 text-base"></i>
                安卓版下载
              </button>
            </div>
          </div>
          <div className="flex-1 flex justify-center">
            <div className="relative w-48 h-80 md:w-56 md:h-[360px] rounded-2xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=A%20modern%20smartphone%20mockup%20displaying%20a%20news%20and%20gossip%20app%20interface%20with%20warm%20orange%20and%20cream%20color%20scheme%2C%20clean%20UI%20design%20with%20cards%20and%20rankings%2C%20minimalist%20flat%20design%20style%2C%20soft%20lighting%2C%20app%20screen%20showing%20trending%20topics%20and%20hot%20news%20items%2C%20editorial%20mobile%20app%20design%20aesthetic&width=560&height=900&seq=app-mockup-x1&orientation=portrait"
                alt="每日爆料移动客户端界面展示"
                className="w-full h-full object-cover"
                title="每日爆料App - 随时随地吃瓜爆料"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}